<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body.form__body_small(action='javascript://' v-if='params')
            template(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options='viewTypes',
                            :show-labels='false',
                            :allow-empty='false',
                            track-by='name',
                            label='name',
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                            v-model='selectedGameType',
                            @select='params.type = $event.type'
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfItemsInTheRoom') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfItemsInTheRoom",
                            :max="10",
                            :min="3",
                            @increase="increaseAmountOfItemsInTheRoom",
                            @decrease="decreaseAmountOfItemsInTheRoom",
                            @input="params.amountOfItemsInTheRoom = $event",
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWordsInChain') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfWordsInChain",
                            :max="3",
                            :min="1",
                            @increase="increaseAmountOfWordsInChain",
                            @decrease="decreaseAmountOfWordsInChain",
                            @input="params.amountOfWordsInChain = $event",
                        )
                .form__field
                     label.form__label
                         | {{ $i18n.t('trainer.trainer_gameFormSetting_inOrder') }}
                     .form__field-body-checkbox
                          cs-checkbox(
                            v-model="params.inOrder"
                            :checked="params && params.inOrder"
                          )
                .form__field
                    label.form__label
                          | {{ $i18n.t('trainer.trainer_gameFormSetting_difficultWords') }}
                    .form__field-body-checkbox
                          cs-checkbox(
                            v-model="params.difficultWords"
                            :checked="params && params.difficultWords"
                          )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '@/utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import { cloneDeep, find } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        data() {
            return {
                viewTypes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_words'),
                        type: 'words',
                    },
                ],
                selectedGameType: null,
                amountOfItemsInTheRoom: 1,
                amountOfWordsInChain: 1,
                params: null,
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                if (this.game && this.game.slug === this.slug) {
                    this.params = cloneDeep(this.game);
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameType = find(this.viewTypes, { type: this.params.type });
        },
        updated() {
            this.selectedGameType = find(this.viewTypes, { type: this.params.type });
        },
        computed: {
            ...mapState({
                game: state => state.trainer.game,
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
        },
        methods: {
            increaseAmountOfItemsInTheRoom() {
                if (this.params.amountOfItemsInTheRoom <= 10) {
                    this.params.amountOfItemsInTheRoom += 1;
                }
            },
            decreaseAmountOfItemsInTheRoom() {
                if (this.params.amountOfItemsInTheRoom >= 1) {
                    this.params.amountOfItemsInTheRoom -= 1;
                }
            },
            increaseAmountOfWordsInChain() {
                if (this.params.amountOfWordsInChain <= 3) {
                    this.params.amountOfWordsInChain += 1;
                }
            },
            decreaseAmountOfWordsInChain() {
                if (this.params.amountOfWordsInChain >= 1) {
                    this.params.amountOfWordsInChain -= 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__body_small {
        margin: 0 auto;
        max-width: 1020px;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
